// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"7dc02595","695":"9f0aac24"}[chunkId] + ".chunk.js";
};